const HUGGING_FACE_BASE_URL = 'https://huggingface.co/'

function stripTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

export function getHuggingFaceMirrorBaseUrl() {
  const value = import.meta.env.VITE_HF_MODEL_MIRROR_BASE_URL
  if (!value || !value.trim()) {
    return null
  }

  return stripTrailingSlash(value.trim())
}

export function rewriteHuggingFaceAssetUrl(url: string) {
  const mirrorBaseUrl = getHuggingFaceMirrorBaseUrl()
  if (!mirrorBaseUrl) {
    return url
  }

  if (!url.startsWith(HUGGING_FACE_BASE_URL)) {
    return url
  }

  return `${mirrorBaseUrl}/${url.slice(HUGGING_FACE_BASE_URL.length)}`
}

export async function withHuggingFaceMirrorFetch<T>(task: () => Promise<T>) {
  const mirrorBaseUrl = getHuggingFaceMirrorBaseUrl()
  if (!mirrorBaseUrl || typeof globalThis.fetch !== 'function') {
    return task()
  }

  const originalFetch = globalThis.fetch.bind(globalThis)

  globalThis.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === 'string') {
      return originalFetch(rewriteHuggingFaceAssetUrl(input), init)
    }

    if (input instanceof URL) {
      return originalFetch(rewriteHuggingFaceAssetUrl(input.toString()), init)
    }

    if (input instanceof Request) {
      return originalFetch(new Request(rewriteHuggingFaceAssetUrl(input.url), input), init)
    }

    return originalFetch(input, init)
  }) as typeof globalThis.fetch

  try {
    return await task()
  } finally {
    globalThis.fetch = originalFetch
  }
}